import React from 'react'

const Theme3Nophotocouple = ({values}) => {

  const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t3-preview-single-couple-container">

        <div className="t3-preview-couple-grandparents">
           {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t3-preview-couple-name">
          {fullname}
        </h1>

        <div className="t3-preview-couple-parents">
            {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

    const groomCard = () =>
    renderPersonCard({
      image: values.groomImage,
      alt: "groomImage",
      fullname: values.groomFullName || "Groom Full Name",
      parentprefix: values.groomParentsPrefix,
      parentsName: values.groomParents,
      grandParentsPrefix: values.groomGrandParentsPrefix,
      grandParentsName: values.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      image: values.brideImage,
      alt: "brideImage",
      fullname: values.brideFullName || "Bride Full Name",
      parentprefix: values.brideParentsPrefix,
      parentsName: values.brideParents,
      grandParentsPrefix: values.brideGrandParentsPrefix,
      grandParentsName: values.brideGrandParents,
    });

    
  return (
    <div className="t3-couple-section t3-nophoto-couple">
     <div className="theme-3-prview-couple">
       <div className="theme-3-preview-couple-card">
         <div className="t3-preview-couple-inner-content">
                <h1 className='t3-preview-couple-heading'>{values?.sectionHeading}</h1>

   <div className="t3-preview-couple-wrapper">
               {values.displayOrder==="groomFirst" ?(
                       <>
                         {groomCard()}

                           <span className="t3-preview-couple-divider">
                        &
                    </span>

                    {brideCard()}

                       </>
                  ):(
                          <>
                              {brideCard()}
                              

                           <span className="t3-preview-couple-divider">
                        &
                    </span>
                          {groomCard()}
                   
                          </>
                  )}
           </div>
         </div> 
       </div>
     </div>
    </div>
  )
}

export default Theme3Nophotocouple